export default __webpack_public_path__ + "static/media/wisdom-section-illustration.826ebc7b.jpg";